const normalizePolicyText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

const enhanceFoxnaroPolicyPage = () => {
  if (!document.body.classList.contains('foxnaro-policy')) return;

  const policyContent = document.querySelector('.shopify-policy__body .rte');
  if (!(policyContent instanceof HTMLElement)) return;

  const policyPath = window.location.pathname.replace(/\/+$/, '');
  const duplicateTitles = {
    '/policies/refund-policy': 'Return & Refund Policy',
    '/policies/shipping-policy': 'Shipping Policy',
    '/policies/contact-information': 'Contact Information',
    '/policies/legal-notice': 'Legal Notice',
  };
  const duplicateTitle = duplicateTitles[policyPath];
  const firstContentElement = Array.from(policyContent.children).find((element) => element.textContent.trim());

  if (
    duplicateTitle &&
    firstContentElement instanceof HTMLElement &&
    normalizePolicyText(firstContentElement.textContent) === normalizePolicyText(duplicateTitle)
  ) {
    firstContentElement.classList.add('foxnaro-policy__duplicate-heading');
    firstContentElement.hidden = true;
  }

  if (policyPath !== '/policies/contact-information') return;

  const emailAddress = 'support@foxnaro.com';
  const emailParagraph = Array.from(policyContent.children).find(
    (element) =>
      element instanceof HTMLParagraphElement &&
      normalizePolicyText(element.textContent) === normalizePolicyText(`Email: ${emailAddress}`)
  );

  if (!(emailParagraph instanceof HTMLParagraphElement)) return;

  emailParagraph.classList.add('foxnaro-policy__contact-email');

  if (!emailParagraph.querySelector('a[href^="mailto:"]')) {
    const emailLink = document.createElement('a');
    emailLink.href = `mailto:${emailAddress}`;
    emailLink.textContent = emailAddress;
    emailParagraph.replaceChildren(document.createTextNode('Email: '), emailLink);
  }

  if (!policyContent.querySelector('.foxnaro-policy__response-time')) {
    const responseTime = document.createElement('p');
    responseTime.className = 'foxnaro-policy__response-time';
    responseTime.textContent = 'We typically respond within 1–2 business days.';
    emailParagraph.insertAdjacentElement('afterend', responseTime);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceFoxnaroPolicyPage, { once: true });
} else {
  enhanceFoxnaroPolicyPage();
}
